// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// "Unassigned Projects" is the dashboard's default filter, not a deliberate choice, so a search
// made without ever touching the dropdown should span every folder (searching doesn't feel like
// browsing). Once the user explicitly picks a filter - including re-picking "Unassigned
// Projects" - it's honored as-is, search or not.
//
// A plain function with no store dependency, because two callers need the rule: the memoized
// selector that builds every request, and the reducer that decides whether a just-assigned
// project still belongs in the rendered set.
//
// Inside a folder (the map view scoped to one, AUT-6432) every project is assigned to it, so the
// Unassigned filter would select nothing - it reads as All there.
export const resolveEffectiveOrderSortFilter = (
  orderSortFilter: string,
  orderSortFilterTouched: boolean,
  keywordFilter: string,
  mapFolderId: string | null = null,
): string => {
  if (mapFolderId && orderSortFilter === 'unassigned') return 'all';
  return (orderSortFilter === 'unassigned' && !orderSortFilterTouched && keywordFilter) ? 'all' : orderSortFilter;
};

export default resolveEffectiveOrderSortFilter;
